/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// plugin
	var canvas = __webpack_require__(1);
	var snowfall = __webpack_require__(2);
	
	// modules
	var topScratch = __webpack_require__(3);
	var formSelect = __webpack_require__(4);
	var formHalf = __webpack_require__(5);
	var recipeModal = __webpack_require__(6);
	var shareBtn = __webpack_require__(7);
	
	// functions
	$('.js-scratch').each(function(){
	  var scratch = new Scratch(this);
	});
	
	$('.js-select').each(function(){
	  var formselect = new FormSelect(this);
	});
	
	$('.js-half').each(function(){
	  var formhalf = new FormHalf(this);
	});
	
	$('.js-recipe-bt').each(function(){
	  var recipemodal = new Modal(this);
	});
	
	$('.js-share').each(function(){
	  var sharebtn = new Share(this);
	});
	
	$('.js-swap').on('click', function(){
	  $(this).parent().next().removeClass('is-hidden');
	  $(this).remove();
	});
	
	
	$(function(){
	$('.slider').slick({
	autoplay:true,
	autoplaySpeed:2000,
	dots:true,
	pauseOnHover:true
	});
	});


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	/*
	 * jFlip plugin for jQuery v0.4 (28/2/2009)
	 * 
	 * A plugin to make a page flipping gallery    
	 *
	 * Copyright (c) 2008-2009 Renato Formato (rformato@gmail.com)
	 * Dual licensed under the MIT (MIT-LICENSE.txt)
	 * and GPL (GPL-LICENSE.txt) licenses.
	 *    
	 */
	;(function($){
	    var Flip = function(canvas,width,height,images,opts) {
	
	      var ua = navigator.userAgent.toLowerCase();
	      var ver = navigator.appVersion.toLowerCase();
	
	      // IE(11以外)
	      var isMSIE = (ua.indexOf('msie') > -1) && (ua.indexOf('opera') == -1);
	      // IE6
	      var isIE6 = isMSIE && (ver.indexOf('msie 6.') > -1);
	      // IE7
	      var isIE7 = isMSIE && (ver.indexOf('msie 7.') > -1);
	      // IE8
	      var isIE8 = isMSIE && (ver.indexOf('msie 8.') > -1);
	      // IE9
	      var isIE9 = isMSIE && (ver.indexOf('msie 9.') > -1);
	      // IE10
	      var isIE10 = isMSIE && (ver.indexOf('msie 10.') > -1);
	      // IE11
	      var isIE11 = (ua.indexOf('trident/7') > -1);
	      // IE
	      var isIE = isMSIE || isIE11;
	      // OLD IE
	      var isOldIE = isIE8 || isIE7 || isIE6;
	      // Edge
	      var isEdge = (ua.indexOf('edge') > -1);
	       
	      // Google Chrome
	      var isChrome = (ua.indexOf('chrome') > -1) && (ua.indexOf('edge') == -1);
	      // Firefox
	      var isFirefox = (ua.indexOf('firefox') > -1);
	      // Safari
	      var isSafari = (ua.indexOf('safari') > -1) && (ua.indexOf('chrome') == -1);
	      // Opera
	      var isOpera = (ua.indexOf('opera') > -1);
	
	      //private vars
	      opts = $.extend({
	        background:"green",
	        cornersTop:true,
	        scale:"noresize",
	        spped: 0
	      },opts);
	
	      var obj = this,
	          el = canvas.prev(),
	          index = 0,
	          init = false,
	          background = opts.background,
	          cornersTop = opts.cornersTop,
	          gradientColors = opts.gradientColors || ['#4F2727','#FF8F8F','#F00'],
	          curlSize = opts.curlSize || 0.1,
	          scale = opts.scale,
	          patterns = [],
	          canvas2 = canvas.clone(),
	          ctx2 = isOldIE?null:canvas2[0].getContext("2d"),
	          canvas = isOldIE?$(G_vmlCanvasManager.initElement(canvas[0])):canvas,
	          ctx = canvas[0].getContext("2d"),
	          loaded = 0;
	
	      // 2倍にする
	      ctx.scale(2, 2);
	
	      var images = images.each(function(i){
	        if(patterns[i]) return;
	        var img = this;
	        img.onload = function() {
	          var r = 1;
	          if(scale!="noresize") {
	            var rx = width/this.width,
	                ry = height/this.height;
	            if(scale=="fit"){
	              r = (rx<1 || ry<1)?Math.min(rx,ry):1;
	            }
	            if(scale=="fill") {
	              r = Math.min(rx,ry);
	            }
	          };
	          $(img).data("flip.scale",r);
	          patterns[i] = ctx.createPattern(img,"no-repeat");
	          loaded++;
	          if(loaded==images.length && !init) {
	            init = true;
	            draw();
	          }
	        };
	        if(img.complete)
	          window.setTimeout(function(){img.onload()},10);
	      }).get();
	
	      var width = width,
	          height = height,
	          mX = width,
	          mY = height,
	          basemX = mX*(1-curlSize),
	          basemY = mY*curlSize,
	          sideLeft = false,
	          off = isOldIE?canvas.offset():null,
	          onCorner = false,
	          curlDuration=400,
	          curling = false,
	          animationTimer,
	          startDate,
	          flipDuration=700,
	          flipping = false,
	          baseFlipX,
	          baseFlipY,
	          lastmX,
	          lastmY,
	          inCanvas = false,
	          mousedown = false,
	          dragging = false,
	          isStart = false;
	      
	      $(window).scroll(function(){
	        //off = canvas.offset(); //update offset on scroll
	      });
	      
	      //IE can't handle correctly mouseenter and mouseleave on VML 
	      var c = isOldIE?(function(){
	          var div = $("<div>").width(width).height(height).css({position:"absolute",cursor:"default",zIndex:1}).appendTo("body");
	          //second hack for IE7 that can't handle correctly mouseenter and mouseleave if the div has no background color 
	          // if(parseInt($.browser.version)==7)
	          //   div.css({opacity:0.000001,background:"#FFF"});
	          var positionDiv = function() {
	            off = canvas.offset();
	            return div.css({left:off.left+'px',top:off.top+'px'});
	          }
	          $(window).resize(positionDiv);
	          return positionDiv();
	      })():canvas;
	
	      c.ready(function(e){
	        inCanvas = true;
	        window.clearInterval(animationTimer);
	        startDate = new Date().getTime();
	        animationTimer = window.setInterval(cornerCurlIn,10);
	      });
	
	      // onClickで再生開始
	      c.on('click',function(){
	        if(!isStart){
	          start();
	        }
	      });
	
	      // 開始
	      var start = function(e){
	        var i = 0;
	        isStart = true;
	        flipping = true;
	        play();
	        i++;
	        autoPlay(i);
	      };
	
	      // 自動再生する
	      var autoPlay = function(i){
	        var timer = setInterval(function(){
	          if(i >= images.length-1){
	            clearInterval(timer);
	          } else {
	            play()
	            i++;
	          }
	        }, opts.speed);
	      };
	
	      var play = function(){
	        window.clearInterval(animationTimer);
	        startDate = new Date().getTime();
	        baseFlipX = mX;
	        baseFlipY = mY;
	        animationTimer = window.setInterval(flip,10);
	        index += sideLeft?-1:1;
	        el.trigger("flip.jflip",[index,images.length]);
	      };
	      
	      var flip = function() {
	        var date = new Date(),
	            delta = date.getTime()-startDate;
	        if(delta>=flipDuration) {
	          window.clearInterval(animationTimer);
	          images.push(images.shift());
	          patterns.push(patterns.shift());         
	          mX = width;
	          mY = height; 
	          draw();
	          flipping = false;
	          //init corner move if still in Canvas
	          if(inCanvas) {
	            startDate = new Date().getTime();
	            animationTimer = window.setInterval(cornerCurlIn,10);
	            // c.triggerHandler("mousemove");
	          } 
	          return;
	        }
	        //da mX a -width  (mX+width) in duration millisecondi 
	        mX = baseFlipX-2*(width)*delta/flipDuration;
	        mY = baseFlipY+2*(height)*delta/flipDuration;
	        draw();
	      },
	      // cornerMove =  function() {
	      //   // console.log('cornerMove');
	      //   var date = new Date(),delta = date.getTime()-startDate;
	        
	      //   mX = basemX+Math.sin(Math.PI*2*delta/1000);
	      //   mY = basemY+Math.cos(Math.PI*2*delta/1000);
	      //   drawing = true;
	      //   window.setTimeout(draw,0);
	      // },
	      cornerCurlIn = function() {
	        // console.log('cornerCurlIn');
	        var date = new Date(),
	            delta = date.getTime()-startDate;
	        if(delta>=curlDuration) {
	          window.clearInterval(animationTimer);
	          startDate = new Date().getTime();
	          // animationTimer = window.setInterval(cornerMove,10);        
	        }      
	        mX = width-(width-basemX)*delta/curlDuration;
	        mY = basemY*delta/curlDuration;
	        draw();    
	      },
	      // cornerCurlOut = function() {
	      //   console.log('cornerCurlOut');
	      //   var date = new Date(),delta = date.getTime()-startDate;
	      //   if(delta>=curlDuration) {
	      //     window.clearInterval(animationTimer);
	      //   }      
	      //   mX = basemX+(width-basemX)*delta/curlDuration;
	      //   mY = basemY-basemY*delta/curlDuration;
	      //   draw();    
	      // },
	      curlShape = function(m,q) {
	        // console.log('curlShape');
	        //cannot draw outside the viewport because of IE blurring the pattern
	        var intyW = m*width+q,intx0 = -q/m;
	        if(isOldIE) {
	          intyW = Math.round(intyW);
	          intx0 = Math.round(intx0);
	        };
	        ctx.beginPath();
	        ctx.moveTo(width,Math.min(intyW,height));
	        ctx.lineTo(width,0);
	        ctx.lineTo(Math.max(intx0,0),0);
	        if(intx0<0) {
	          ctx.lineTo(0,Math.min(q,height));
	          if(q<height) {
	            ctx.lineTo((height-q)/m,height);
	          }
	          ctx.lineTo(width,height);
	        } else {
	          if(intyW<height)
	            ctx.lineTo(width,intyW);
	          else {
	            ctx.lineTo((height-q)/m,height);
	            ctx.lineTo(width,height);
	          }
	        }
	      },
	      draw = function() {
	        // console.log('draw');
	        if(!init) return;
	        if(isOldIE)
	          ctx.clearRect(0,0,width,height);
	
	        ctx.fillStyle = background;
	        ctx.fillRect(0,0,width,height);
	        var img = images[0], r = $(img).data("flip.scale");
	        if(isOldIE) {
	          ctx.fillStyle = patterns[0];
	          ctx.fillStyle.width2 = ctx.fillStyle.width*r;
	          ctx.fillStyle.height2 = ctx.fillStyle.height*r;
	          ctx.fillRect(0,0,width,height);
	        } else {
	          ctx.drawImage(img,(width-img.width*r)/2,(height-img.height*r)/2,width,height);
	        }
	        
	        if(mY && mX!=width) {
	          
	          var m = 2,
	              q = (mY-m*(mX+width))/2;
	              m2 = mY/(width-mX),
	              q2 = mX*m2;
	          if(m==m2) return;
	
	          var sx=1,sy=1,tx=0,ty=0;
	          ctx.save();
	          if(sideLeft) {
	            tx = width;
	            sx = -1;
	          }
	          if(!cornersTop) {
	            ty = height;
	            sy = -1;
	          }
	          ctx.translate(tx,ty);
	          ctx.scale(sx,sy);
	          //draw page flip
	          //intx,inty is the intersection between the line of the curl and the line
	          //from the canvas corner to the curl point 
	          var intx = (q2-q)/(m-m2);
	          var inty = m*intx+q;
	          //y=m*x+mY-m*mX line per (mX,mY) parallel to the curl line
	          //y=-x/m+inty+intx/m line perpendicular to the curl line
	          //intersection x between the 2 lines = int2x
	          //y of perpendicular for the intersection x = int2y 
	          //opera do not fill a shape if gradient is finished
	          var int2x = (2*inty+intx+2*m*mX-2*mY)/(2*m+1);
	          var int2y = -int2x/m+inty+intx/m;
	          var d = Math.sqrt(Math.pow(intx-int2x,2)+Math.pow(inty-int2y,2));
	          var stopHighlight = Math.min(d*0.5,30);
	          
	          var c;
	          if(!isFirefox) {
	            c = ctx;
	          } else {
	            c = ctx2;
	            c.clearRect(0,0,width,height);
	            c.save();
	            c.translate(1,0); //the curl shapes do not overlap perfeclty
	          }
	          var gradient = c.createLinearGradient(intx,inty,int2x,int2y);
	          gradient.addColorStop(0, gradientColors[0]);
	          gradient.addColorStop(stopHighlight/d, gradientColors[1]);
	          gradient.addColorStop(1, gradientColors[2]);
	          c.fillStyle = gradient;
	          c.beginPath();
	          c.moveTo(-q/m,0);
	          c.quadraticCurveTo((-q/m+mX)/2+0.02*mX,mY/2,mX,mY);
	          c.quadraticCurveTo((width+mX)/2,(m*width+q+mY)/2-0.02*(height-mY),width,m*width+q);
	          if(!isFirefox) {
	            c.fill();
	          } else {
	            //for ff 2.0 use a clip region on a second canvas and copy all its content (much faster)
	            c.save();
	            c.clip();
	            c.fillRect(0,0,width,height);
	            c.restore();
	            ctx.drawImage(canvas2[0],0,0);
	            c.restore();          
	          }
	          //can't understand why this doesn't work on ff 2, fill is slow
	          /*
	          ctx.save();
	          ctx.clip();
	          ctx.fillRect(0,0,width,height);
	          ctx.restore();
	          */
	          gradient = null;
	                    
	          //draw solid color background
	          ctx.fillStyle = background;
	          curlShape(m,q);
	          ctx.fill();
	
	          //draw back image
	          curlShape(m,q);
	          //safari and opera delete the path when doing restore
	          if(!isSafari && !isOpera)
	            ctx.restore();          
	
	          var img = sideLeft?images[images.length-1]:images[1];
	          r = $(img).data("flip.scale");
	          if(isOldIE) {
	            //excanvas does not support clip
	            ctx.fillStyle = sideLeft?patterns[patterns.length-1]:patterns[1];
	            //hack to scale the pattern on IE (modified excanvas)
	            ctx.fillStyle.width2 = ctx.fillStyle.width*r;
	            ctx.fillStyle.height2 = ctx.fillStyle.height*r;
	            ctx.fill();
	          } else {
	            ctx.save();
	            ctx.clip();
	            //safari and opera delete the path when doing restore
	            //at this point we have not reverted the trasform
	            if(isSafari || isOpera) {
	              //revert transform
	              ctx.scale(1/sx,1/sy);
	              ctx.translate(-tx,-ty);
	            }            
	
	
	            ctx.drawImage(img,(width-img.width*r)/2,(height-img.height*r)/2,img.width*r,img.height*r);
	
	            //ctx.drawImage(img,(width-img.width)/2,(height-img.height)/2);
	            ctx.restore();
	            if(isSafari || isOpera) 
	              ctx.restore()
	          }
	        }   
	      }
	    }
	
	    $.fn.jFlip = function(width,height,opts){
	      return this.each(function() {
	        // $(this).wrap("<div class='flip_gallery'>");
	        var images = $(this).find("img");
	        //cannot hide because explorer does not give the image dimensions if hidden
	        // 2倍にする
	        var canvas = $(document.createElement("canvas")).attr({width:width*2,height:height*2}).css({width:width+"px",height:height+"px"});
	        // var canvas = $(document.createElement("canvas")).attr({width:width,height:height}).css({width:width+"px",height:height+"px"})
	        $(this).css({position:"absolute",left:"-9000px",top:"-9000px"}).after(canvas);
	        new Flip($(this).next(),width || 300,height || 300,images,opts);
	      });
	    };
	    
	})(jQuery);
	
	
	


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	/*  Snowfall jquery plugin 
	  version 1.2, Dec 20 2009
	  Developed by Jason Brown for any bugs or questions email me at loktar69@hotmail
	  info on the plugin is located on Somethinghitme.com
	  
	  values for snow options are
	  
	  flakeCount,
	  flakeColor,
	  flakeIndex,
	  minSize,
	  maxSize,
	  minSpeed,
	  maxSpeed
	  
	  Example Usage :
	  $(document).snowfall({flakeCount : 100, maxSpeed : 10});
	  
	  -or-
	  
	  $('#element').snowfall({flakeCount : 800, maxSpeed : 5, maxSize : 5});
	  
	  -or with defaults-
	  
	  $(document).snowfall();
	*/
	
	(function($){
	  $.fn.snowfall = function(options){
	    
	    var element = this;
	    
	    // random fuction for generating random vals
	    random = function random(min, max){
	      return Math.round(min + Math.random()*(max-min)); 
	    }
	    
	    
	    // Randam Array Tree-Web custom 2011/10/29
	    function randArray(_str){
	       var i = _str.length;
	      while (i) {
	         var y = Math.floor(Math.random()*i);
	         var t = _str[--i];
	          _str[i] = _str[y];
	          _str[y] = t;
	      }
	      return _str;
	    }
	    
	    
	    // snow flake class
	    function Flake(_x, _y, _size, _speed)
	    {
	      // Flake properties
	      this.id = flakeId; 
	      this.x  = _x;
	      this.y  = _y;
	      this.size = _size;
	      this.speed = _speed;
	      this.step = 0,
	      this.stepSize = random(1,10) / 100;
	      
	         //original
	      //var flakeMarkup = "<div id='flake-" + this.id + "' style='width: " + this.size + "px; height: " + this.size + "px; background: " + options.flakeColor + "; position: absolute; top: " + this.y + "px; left:" + this.x + "px; font-size: 0px; z-index: " + options.flakeIndex + ";'></div>";
	         
	         //Tree-Web custom (2010/12/10)
	         var angle = Math.round(Math.random()*360);
	      var flakeMarkup = "<img src='"+ randArray(options.image)[0] +"' id='flake-" + this.id;
	      flakeMarkup += "' style='width: " + this.size + "px; height: " + this.size + "px;";
	      flakeMarkup += "; position: absolute; top: " + this.y + "px; left:" + this.x + "px; font-size: 0px; z-index: " + options.flakeIndex;
	         
	         // CSS 3
	         flakeMarkup += "; -moz-transform:rotate(" + angle + "deg);";
	         flakeMarkup += "-webkit-transform:rotate(" + angle + "deg);";
	         flakeMarkup += "transform:rotate(" + angle + "deg);";
	      flakeMarkup += "' />";
	         //
	         
	      if($(element).get(0).tagName === $(document).get(0).tagName){
	        $('body').append(flakeMarkup);
	      }else{
	        $(element).append(flakeMarkup);
	      }
	      
	      this.element = document.getElementById('flake-' + this.id);
	      
	      // Update function, used to update the snow flakes, and checks current snowflake against bounds
	      this.update = function(){
	        this.y += this.speed;
	        
	        if(this.y > (elHeight) -20){
	          this.reset();
	        }
	        
	        this.element.style.top = this.y + 'px';
	        this.element.style.left = this.x + 'px';
	        
	        this.step += this.stepSize;
	        this.x += Math.cos(this.step);
	        
	        if(this.x > (elWidth) - 22 || this.x < 22){
	          this.reset();
	        }
	      }
	      
	      // Resets the snowflake once it reaches one of the bounds set
	      this.reset = function(){
	        this.y = 0;
	        this.x = random(0, elWidth);
	        this.stepSize = random(1,10) / 100;
	        this.size = random((options.minSize * 100), (options.maxSize * 100)) / 100;
	        this.speed = random(options.minSpeed, options.maxSpeed);
	      }
	    }
	  
	    // plugin vars
	    var flakes = [],
	      flakeId = 0,
	      i = 0,
	      elHeight = $(element).height(),
	      elWidth = $(element).width(),
	      defaults = {
	        flakeCount : 35,
	        flakeColor : '#ffffff',
	        flakeIndex: 999999,
	        minSize : 1,
	        maxSize : 3,
	        minSpeed : 2,
	        maxSpeed : 3,
	            image:'image.png'
	        },
	      options = $.extend(defaults, options);    
	    
	    // Bind the window resize event so we can get the innerHeight again
	    $(window).bind("resize", function(){  
	      elHeight = $(element).height();
	      elWidth = $(element).width();
	    }); 
	    
	
	    // initialize the flakes
	    for(i = 0; i < options.flakeCount; i+=1){
	      flakeId = i;
	      flakes[i] = new Flake(random(0,elWidth), random(0, elHeight), random((options.minSize * 100), (options.maxSize * 100)) / 100, random(options.minSpeed, options.maxSpeed));
	    }
	  
	    // this controls flow of the updating snow
	    function snow(){
	      for( i = 0; i < options.flakeCount; i += 1){
	        flakes[i].update();
	      }
	      
	      setTimeout(function(){snow()}, 30);
	    }
	    
	    snow();
	  };
	})(jQuery);


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/**
	* スクラッチのコンストラクタ
	* @constructor
	* @param {selector} el - セレクタ
	*/
	module.exports = Scratch = function(el){
	  this.element = $(el);
	  this.checkDevice();
	  this.init();
	};
	
	/**
	* initialize
	*/
	Scratch.prototype.init = function(){
	  var self = this;
	  this.daily = $('.js-scratch-daily');
	  this.panel = $('.js-scratch-panel');
	  this.scratch = $('#jsScratchAnimation');
	  this.win = $('.js-scratch-confetti');
	  this.recipes = [
	    {
	      'intro': 'こんにちは！かんたん2ステップであっという間に出来上がる・・・',
	      'name': 'ごちカツくんだポ！！',
	      'desc': '揚げないタイプのトンカツだからさっぱりヘルシーだポ。',
	      'menu': '2ステップでカンタン！ 今日はごちカツ作ろう！'
	    },
	    {
	      'intro': 'ハロー！ステキな厚切りステーキの…',
	      'name': 'ごちテキくんだポォ〜！！',
	      'desc': '弱火でじっくり焼くと、お肉が柔らかジューシーに仕上がるポォ〜！！',
	      'menu': 'ステキな厚切りステーキ 今日はごちテキ作ろう！'
	    },
	    {
	      'intro': '今日もありがとッス！ちょっとピリ辛でご飯がモリモリ進んじゃう…',
	      'name': 'ごちしょうがくんッス！！',
	      'desc': '味の決め手は豆板醤ッス！今日もモリモリ食べるッス！ポ！！',
	      'menu': 'ちょっとピリ辛 今日はごちしょうが作ろう！'
	    },
	    {
	      'intro': 'ご機嫌いかが？お肉と一緒に野菜もたっぷり摂れちゃう…',
	      'name': 'ごちしゃぶくんですポ！！',
	      'desc': 'すりごまソースのビタミンEでお肌もキレイになっちゃうポ！',
	      'menu': '野菜もモリモリ食べられる 今日はごちしゃぶ作ろう！'
	    },
	    {
	      'intro': 'こんにちは！超かんたんジューシーでスペシャルな一品…',
	      'name': 'ごちローストくんだポ！！',
	      'desc': '塩コショウしてオーブンに入れるだけ!ごちポの代表的料理だポ！！',
	      'menu': '超カンタンやわらかな 今日はごちロースト作ろう！'
	    },
	    {
	      'intro': '毎度どうも！トロッとやわらか味わい深い…',
	      'name': 'ごち煮くんと申しますポ！！',
	      'desc': 'かたまり肉から切り出して作るとよりリーズナブルだポ！',
	      'menu': 'とろけるうまさの 今日はごち煮作ろう！'
	    }
	  ];
	  this.confettis = [
	    '/images/confetti/01.png',
	    '/images/confetti/02.png',
	    '/images/confetti/03.png',
	    '/images/confetti/04.png'
	  ];
	  this.event();
	};
	
	/**
	* イベント
	*/
	Scratch.prototype.event = function(){
	  var self = this;
	
	  // 日めくり
	  this.initDaily();
	
	  // canvas ok
	  var hasCanvas = !!window.HTMLCanvasElement;
	  if(hasCanvas){
	    this.initCanvas();
	  }else{
	    this.panel.find('li').on('click', function(){
	      self.changePanelClass($(this));
	    });
	  }
	  
	
	  // 表示
	  this.element.addClass('is-ready');
	  this.panel.eq(0).addClass('is-visible');
	
	  // スクラッチ
	  if(this.scratch.length){
	    var PRELOAD_TIME = 2000;
	    var FRAME_RATE = 25;
	    var FRAME_TIME = 100;
	    var imgPath = this.scratch.css('background-image');
	    imgPath = imgPath.replace('url(','').replace(')','').replace(/\"/gi, "");
	    this.preload(imgPath, PRELOAD_TIME).done(function(){
	      self.element.addClass('is-start');
	      self.animation(FRAME_RATE, FRAME_TIME);
	    });
	  }
	
	  // result
	  if(this.win.length){
	    this.result(this.win);
	  }
	};
	
	/**
	* 日替わりを生成
	*/
	Scratch.prototype.initDaily = function(){
	  var self = this;
	
	  // 21日にカツになるようプラスする
	  var PLUS_DATE = 3;
	
	  // 開始日
	  var START_DATE = '0421';
	
	  // 日付に応じてDOM変更
	  var today = this.getDate();
	  var recipeNum = (today[1] + PLUS_DATE) % this.recipes.length;
	
	  var calendarDate = this.zeroPadding(today);
	  calendarDate = (calendarDate >= START_DATE) ? calendarDate : START_DATE ;
	
	  var dom = '';
	  dom += '<ul class="scratch-canvas js-scratch-canvas">';
	  dom += '<li><img src="/images/calendar/cal_'+calendarDate+'.png" alt="'+today[0]+'月'+today[1]+'月"></li>';
	  dom += '<li><img src="/images/intro/intro_01.png" alt="いろんなごちポを紹介するポ！"></li>';
	  dom += '<li><img src="/images/intro/intro_02_'+(recipeNum+1)+'.png" alt="'+this.recipes[recipeNum].intro+'"></li>';
	  dom += '<li><img src="/images/intro/intro_03_'+(recipeNum+1)+'.png" alt="'+this.recipes[recipeNum].name+'"></li>';
	  dom += '<li><img src="/images/intro/intro_04_'+(recipeNum+1)+'.png" alt="'+this.recipes[recipeNum].desc+'"></li>';
	  dom += '<li><img src="/images/intro/intro_05_'+(recipeNum+1)+'.png" alt="'+this.recipes[recipeNum].menu+'"></li>';
	  dom += '<li><img src="/images/intro/intro_07.png" alt=""></li>';
	  dom += '</ul>';
	
	  // DOM生成
	  this.daily.append(dom);
	};
	
	/**
	* 日付取得
	* @return {array} - [month, date]
	*/
	Scratch.prototype.getDate = function(){
	  var self = this;
	  this.date = new Date();
	  var month = this.date.getMonth() +1;
	  var date = this.date.getDate();
	  return [month, date];
	};
	
	/**
	* 日付をゼロパディングする
	* @param {array}
	* @return {string}
	*/
	Scratch.prototype.zeroPadding = function(array){
	  var num = [];
	  for(var i = 0; i < array.length; i++){
	    num.push(('0' + array[i]).substr(-2));
	  }
	  return num[0]+num[1];
	};
	
	/**
	* 日めくり
	*/
	Scratch.prototype.initCanvas = function(){
	  var self = this;
	
	  this.canvas = $('.js-scratch-canvas');
	  this.width = this.canvas.width();
	  this.height = this.canvas.outerHeight();
	
	  var $desc = $('.js-scratch-desc');
	
	  this.canvas.jFlip(this.width,this.height,{
	    background: '#f8f4eb',
	    gradientColors: ['#e5e0d8', '#cecbc4', '#e6e3da'],
	    cornersTop: false,
	    scale: 'fit',
	    curlSize: 0.1,
	    speed: 3000
	  }).bind('flip.jflip',function(event,index,total){
	    if(index === 1){
	      $desc.addClass('is-visible');
	    }
	    if(index+1 === total){
	      var _this = $(this);
	      $desc.removeClass('is-visible');
	      setTimeout(function(){
	        self.changePanelClass(_this);
	      }, 400);
	    }
	  });
	
	  // bugfix for android
	  if(window.navigator && window.navigator.userAgent.indexOf('534.30') > 0){
	    $('canvas').parents('*').css('overflow', 'visible');
	  }
	};
	
	/**
	* scratch-panelのclass付け替え
	* @param {selector} el - セレクタ
	*/
	Scratch.prototype.changePanelClass = function(el){
	  var self = this;
	  this.panel.removeClass('is-visible');
	  el.closest(this.panel).next().addClass('is-visible');
	};
	
	/**
	* スクラッチアニメのスプライト画像プリロード
	* @param {string} path - スプライト画像パス
	* @param {number} time - ローディング早すぎ用の調整時間
	* @return {object} プロミスオブジェクト
	*/
	Scratch.prototype.preload = function(path, time){
	  var self = this;
	
	  var defer = $.Deferred();
	
	  var sprite = new Image();
	  sprite.src = path;
	  sprite.onload = function(){
	    setTimeout(function(){
	      defer.resolve();
	    }, time);
	  }
	  sprite.onerror = function(){
	    defer.reject();
	  }
	
	  return defer.promise();
	};
	
	/**
	* スクラッチアニメーション
	* @param {string} rate - コマ数
	* @param {number} speed - スピード
	*/
	Scratch.prototype.animation = function(rate, speed){
	  var self = this;
	
	  var i = 0;
	  var timer = setInterval(function(){
	    self.scratch.removeClass(function(index, className){
	      return (className.match(/\bani-\S+/g) || []).join(' ');
	    }).addClass('ani-'+i);
	    if(i >= rate-1){
	      clearInterval(timer);
	      setTimeout(function(){
	        window.location.href = 'result';
	      },1500);
	    } else {
	      i++;
	    }
	  }, speed);
	};
	
	/**
	* 紙吹雪
	* @param {selector} el - jqueryセレクタ
	*/
	Scratch.prototype.result = function(el){
	  var self = this;
	
	  var opt = (this.device === 'pc') ? {
	    flakeCount : 300,
	    flakeIndex : 50,
	    maxSpeed : 3,
	    minSpeed : 0.6,
	    maxSize : 14,
	    minSize : 5,
	    image : self.confettis
	  } : {
	    flakeCount : 60,
	    flakeIndex : 50,
	    maxSpeed : 3,
	    minSpeed : 0.6,
	    maxSize : 8,
	    minSize : 4,
	    image : self.confettis
	  } ;
	
	  el.closest('.pj-contents').snowfall(opt);
	};
	
	/**
	* デバイスチェック
	*/
	Scratch.prototype.checkDevice = function(){
	  this.device = $('.sc-main').css('position') == 'relative' ? 'sp' : 'pc';
	}


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/**
	* セレクトエリアのコンストラクタ
	* @constructor
	* @param {selector} el - セレクタ
	*/
	module.exports = FormSelect = function(el){
	  this.element = $(el);
	  this.target = $('.js-select-other');
	  this.event();
	  this.showOther(this.element);
	};
	
	/**
	* イベント
	*/
	FormSelect.prototype.event = function(){
	  var self = this;
	  this.element.on('change',function(e){
	    self.showOther($(this));
	  });
	};
	
	/**
	* その他を表示
	* @param {selector} el - セレクタ
	*/
	FormSelect.prototype.showOther = function(el){
	  var self = this;
	  var selected = el.find('option:selected').attr('id');
	  if(selected === 'other'){
	    this.target.removeClass('is-hidden');
	  }else{
	    this.target.addClass('is-hidden');
	  }
	};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	/**
	* 半角変換のコンストラクタ
	* @constructor
	* @param {selector} el - セレクタ
	*/
	module.exports = FormHalf = function(el){
	  this.element = $(el);
	  this.timer;
	  this.event();
	};
	
	/**
	* イベント
	*/
	FormHalf.prototype.event = function(){
	  var self = this;
	  this.element.on('change',function(e){
	    var value = $(this).val();
	    var newValue = self.changeToHalf(value);
	    $(this).val(newValue);
	  });
	};
	
	/**
	* 変換
	* @param {string} value - 値
	*/
	FormHalf.prototype.changeToHalf = function(value){
	  var self = this;
	  var halfVal = value.replace(/[！-～]/g, function(value){
	    return String.fromCharCode(value.charCodeAt(0) - 0xFEE0);
	  });
	  return halfVal.replace(/”/g, "\"")
	    .replace(/’/g, "'")
	    .replace(/‘/g, "`")
	    .replace(/￥/g, "\\")
	    .replace(/　/g, " ")
	    .replace(/〜/g, "~");
	};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/**
	* モーダルのコンストラクタ
	* @constructor
	* @param {selector} el - セレクタ
	*/
	module.exports = Modal = function(el){
	  this.element = $(el);
	  this.init()
	};
	
	/**
	* initialize
	*/
	Modal.prototype.init = function(){
	  var self = this;
	
	  this.win = $(window);
	  this.doc = $(document);
	  this.checkDevice();
	  this.resize();
	  this.initModal();
	  this.event();
	};
	
	/**
	* モーダル作る
	*/
	Modal.prototype.initModal = function(){
	  var self = this;
	  if(!$('.js-modal').length){
	    var html = '';
	    html += '<div class="sc-modal js-modal">';
	    html += '<div class="sc-modal-content js-modal-content" />';
	    html += '</div>';
	    $('body').append('<div class="sc-modal-overlay js-modal-overlay" />').append(html);
	  };
	
	  this.modal = $('.js-modal');
	  this.modalOverlay = $('.js-modal-overlay');
	  this.modalHtml = $('.js-modal-content');
	};
	
	/**
	* イベント
	*/
	Modal.prototype.event = function(){
	  var self = this;
	
	  this.element.on('click', function(e){
	    if(self.device === 'pc'){
	      e.preventDefault();
	      var href = $(this).attr('href');
	      self.getData(href);
	    }
	  });
	
	  this.doc.on('click', '.js-modal-close, .js-modal-overlay', function(e){
	    e.preventDefault();
	    self.modalRemove();
	  });
	};
	
	/**
	* ajax
	* @param {string} url - 取得するURL
	*/
	Modal.prototype.getData = function(url){
	  var self = this;
	
	  $.ajax({
	    url: url,
	    dataType: 'html'
	  }).then(
	    function(data){
	      self.renderContent(data);
	      ga('send', 'pageview', url);
	    },
	    function(e){
	      alert('通信エラーが発生しました');
	    }
	  );
	};
	
	/**
	* モーダルの中身描画
	* @param {string} data - ajaxで取得したDOM
	*/
	Modal.prototype.renderContent = function(data){
	  var self = this;
	  var $content = $(data).find('.sc-main');
	  var $footer = $content.find('.sc-footer');
	  var $printBtn = $content.find('.sc-recipeItemPrintBtn');
	  var $closeBtn = $content.find('.sc-recipeItemBackBtn');
	  var $closeBtnImg = $closeBtn.find('img');
	  var closeBtnSrc = $closeBtnImg.attr('src').replace('/sp/recipe/recipe_item_backbtn.png', '/pc/recipe/recipe_item_closebtn.png');
	  $footer.remove();
	  $closeBtn.addClass('js-modal-close');
	  $closeBtnImg.attr('src', closeBtnSrc);
	  if($('body').hasClass('js-device--desktop')){
	    $printBtn.addClass('is-visible');
	  }
	  this.modalHtml.prepend($content.html());
	
	  var images = [];
	  var image = this.modalHtml.find('img');
	  for(var i = 0; i < image.length; i++){
	    images.push(image[i].src);
	  }
	  this.preloadAll(images).done(function(){
	    self.modalOpen();
	  });
	};
	
	/**
	* 画像プリロード（ALL）
	* @param {object} arr - 配列
	*/
	Modal.prototype.preloadAll = function(arr){
	  var self = this;
	
	  var defers = arr.map(function(src){
	    return self.preload(src);
	  });
	  return $.when.apply($, defers);
	};
	
	/**
	* 画像プリロード
	* @param {string} src - パス
	*/
	Modal.prototype.preload = function(src){
	  var self = this;
	
	  var defer = $.Deferred();
	
	  var img = new Image();
	  img.src = src;
	  img.onload = function(){
	    defer.resolve();
	  }
	  img.onerror = function(){
	    defer.reject();
	  }
	
	  return defer.promise();
	};
	
	/**
	* モーダル開く
	*/
	Modal.prototype.modalOpen = function(){
	  var self = this;
	  var scrollTop = this.win.scrollTop();
	  this.modalOverlay.addClass('is-active');
	  if(this.modalHtml.height() > this.win.height()){
	    this.modal.addClass('is-scroll');
	  }
	  self.modalPositionSetting(scrollTop);
	  self.modal.scrollTop(0).addClass('is-active');
	};
	
	/**
	* モーダル閉じる
	*/
	Modal.prototype.modalRemove = function(){
	  this.modalOverlay.removeClass('is-active');
	  this.modal.removeClass('is-active is-scroll').removeAttr('style');
	  this.modalHtml.empty();
	};
	
	/**
	* モーダル位置調整
	* @param {number} _t - scroll top
	*/
	Modal.prototype.modalPositionSetting = function(_t){
	  var self = this;
	  this.modal.css({
	    'top': _t + this.win.height() / 2 - this.modal.outerHeight() / 2,
	    'bottom': 'inherit'
	  });
	};
	
	/**
	* リサイズ
	*/
	Modal.prototype.resize = function(){
	  var self = this;
	  var timer = false;
	  this.win.on('resize', function(){
	    if(timer !== false){
	      clearTimeout(timer);
	    }
	    timer = setTimeout(function(){
	      var scrollTop = self.win.scrollTop();
	      self.modalPositionSetting(scrollTop);
	      self.checkDevice();
	    },1000);
	  });
	};
	
	/**
	* デバイスチェック
	*/
	Modal.prototype.checkDevice = function(){
	  this.device = $('.sc-main').css('position') == 'relative' ? 'sp' : 'pc';
	}


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	/**
	* シェアボタンのコンストラクタ
	* @constructor
	* @param {selector} el - セレクタ
	*/
	module.exports = Share = function(el){
	  this.element = $(el);
	  this.url = location.href;
	  this.title = document.title;
	  this.type = this.element.attr('data-share-type');
	  this.event();
	};
	
	/**
	* イベント
	*/
	Share.prototype.event = function(){
	  var self = this;
	  var share;
	  var href = this.element.attr('href');
	  switch (self.type){
	    case 'facebook':
	      share = encodeURIComponent(self.url);
	      break;
	    case 'twitter':
	      share = encodeURIComponent(self.url) + '&text=' + encodeURIComponent(self.title);
	      break;
	    case 'line':
	      share = encodeURIComponent(self.title) + encodeURIComponent(self.url);
	      break;
	  }
	  this.element.attr('href', href + share);
	};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common.js